import React, { forwardRef } from 'react';
import cn from 'classnames';
import Tooltip from '../utility/Tooltip';

import './ToolkitButton.scss';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const ToolkitButton = forwardRef(
  (
    {
      children,
      onClick,
      label,
      className,
      disabled,
      isActive,
      isButton = true,
      ...rest
    },
    ref,
  ) => {
    /**
     * Keydown handler to allow use of
     * - spacebar and return to toggle the bookmark icon
     */
    const keyDownHandler = (event) => {
      // only handle pressing of spacebar and return
      if ([13, 32].includes(event.keyCode)) {
        // Make sure to stop event bubbling
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    };

    const extraProps = {};

    if (typeof isActive !== 'undefined') {
      extraProps['aria-pressed'] = isActive;
    }

    if (isButton) {
      extraProps.role = 'button';
      extraProps.tabIndex = '0';
    }
    return (
      <Tooltip {...rest}>
        <A11y>
          <div
            ref={ref}
            className={cn('ToolkitButton', className, {
              '--disabled': disabled,
            })}
            data-tip
            data-for={rest.target}
            onClick={!disabled ? onClick : null}
            onKeyDown={keyDownHandler}
            aria-label={label}
            {...extraProps}
          >
            <span>{children}</span>
          </div>
        </A11y>
      </Tooltip>
    );
  },
);

export default ToolkitButton;
